<template>
  <!-- Add -->
  <b-modal
    id="modalEdit"
    ref="my-modal"
    title="แก้ไขข้อมูลโครงการ"
    size="lg"
    ok-title="ตกลง"
    cancel-title="ยกเลิก"
    @show="resetModal"
    @hidden="resetModal"
    @ok="handleOk"
  >
    <validation-observer ref="simpleRules">
      <b-row>
        <b-col lg="7">
          <b-form-group
            label="รหัสโครงการ"
            label-for="pj_code"
          >
            <validation-provider
              #default="{ errors }"
              name="Project Code"
              rules="required"
            >
              <b-input-group class="input-group-merge">
                <b-form-input
                  id="pjcode"
                  v-model="editData.pj_code"
                  :state="errors.length > 0 ? false:null"
                  required
                  readonly
                  type="text"
                  placeholder="รหัสโครงการ"
                />
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col lg="5">
          <b-form-group
            label="เลขที่สัญญา"
            label-for="contract_no"
          >
            <validation-provider
              #default="{ errors }"
              name="Contract No"
              rules="required"
            >
              <b-input-group class="input-group-merge">
                <b-form-input
                  id="contractno"
                  v-model="editData.contract_no"
                  :state="errors.length > 0 ? false:null"
                  required
                  type="text"
                  placeholder="เลขที่สัญญา"
                />
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col lg="12">
          <b-form-group
            label="ชื่อโครงการ"
            label-for="pjname"
          >
            <validation-provider
              #default="{ errors }"
              name="Project Name"
              rules="required"
            >
              <b-input-group class="input-group-merge">
                <b-form-input
                  id="pj_name"
                  v-model="editData.pj_name"
                  :state="errors.length > 0 ? false:null"
                  required
                  type="text"
                  placeholder="ชื่อโครงการ"
                />
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col lg="7">
          <b-form-group
            label="หน่วยงานที่รับผิดชอบ"
            label-for="department"
          >
            <validation-provider
              #default="{ errors }"
              name="Department"
              rules="required"
            >
              <v-select
                v-model="selectDepartment"
                :reduce="department => department"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :state="errors.length > 0 ? false:null"
                required
                label="deptname"
                :options="department"
                placeholder="เลือกหน่วยงาน..."
                transition=""
                @input="addDepartment()"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col lg="5">
          <b-form-group
            label="สายทาง"
            label-for="road_id"
          >
            <validation-provider
              #default="{ errors }"
              name="Road"
              rules="required"
            >
              <v-select
                v-model="selectRoad"
                :reduce="road => road"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :state="errors.length > 0 ? false:null"
                required
                label="wayid"
                :options="road"
                placeholder="เลือกสายทาง..."
                transition=""
                @input="addRoad()"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col lg="6">
          <b-form-group
            label="ผู้รับจ้าง"
            label-for="vendor_name"
          >
            <validation-provider
              #default="{ errors }"
              name="Vendor"
              rules="required"
            >
              <v-select
                v-model="editData.vendor_id"
                :reduce="vendor => vendor.vendor_id"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :state="errors.length > 0 ? false:null"
                required
                label="vendor_name"
                :options="vendor"
                placeholder="เลือกผู้รับจ้าง..."
                transition=""
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col lg="3">
          <b-form-group
            label="วันที่รับประกัน"
            label-for="guarantee date start"
          >
            <validation-provider
              #default="{ errors }"
              name="guarantee date start"
              rules="required"
            >
              <b-form-datepicker
                id="guarantee-date-start"
                v-model="date.guarantee_date_start"
                :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                class="mb-2"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col lg="3">
          <b-form-group
            label="วันสิ้นสุดค้ำประกัน"
            label-for="guarantee_date_end"
          >
            <validation-provider
              #default="{ errors }"
              name="guarantee date end"
              rules="required"
            >
              <b-form-datepicker
                id="guarantee-date-end"
                v-model="date.guarantee_date_end"
                :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                class="mb-2"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <template #code>
          {{ codeFeedbackHelper }}
        </template>
      </b-row>
    </validation-observer>
  </b-modal>
</template>

<script>
import axios from '@axios'
import {
  BRow, BCol, BFormGroup, BInputGroup, BFormInput, BFormDatepicker,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { required } from '@validations'
import { ValidationProvider, ValidationObserver } from 'vee-validate'

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BInputGroup,
    BFormInput,
    vSelect,
    ValidationProvider,
    ValidationObserver,
    BFormDatepicker,
  },
  data() {
    return {
      required,
      department: [],
      selectDepartment: [],
      vendor: [],
      selectRoad: [],
      road: [],
      date: {
        guarantee_date_start: '',
        guarantee_date_end: '',
      },
      editData: {
        pj_id: '',
        pj_name: '',
        contract_no: '',
        deptid: '',
        contract_date: '',
        guarantee_date_start: '',
        guarantee_date_end: '',
        guarantee_year: '',
        pj_code: '',
        pj_value: '',
        deptname: '',
        road_id: '',
        vendor_id: '',
      },
    }
  },
  mounted() {
    this.dropdownDepartment()
    this.dropdownVendor()
    this.dropdownRoad()
  },
  methods: {
    sendInfo(id) {
      this.editData.pj_id = id
      axios
        .post('/fetchProject', { pj_id: id })
        .then(response => {
          this.editData.pj_name = response.data.pj_name
          this.editData.contract_no = response.data.contract_no
          this.editData.deptid = response.data.deptid
          this.date.guarantee_date_start = response.data.guarantee_date_start
          this.date.guarantee_date_end = response.data.guarantee_date_end
          this.editData.guarantee_year = response.data.guarantee_year
          this.editData.pj_code = response.data.pj_code
          this.editData.pj_value = response.data.pj_value
          this.selectDepartment = response.data.deptname
          this.editData.deptname = response.data.deptname
          this.editData.deptid = response.data.deptid
          this.editData.road_id = response.data.road_id
          this.editData.road_name = response.data.road_name
          this.editData.vendor_id = response.data.vendor_id
          this.selectRoad = response.data.road_name
        })
        .catch(error => {
          console.log(error)
        })
    },
    getYearDiff(date1, date2) {
      this.editData.guarantee_year = Math.abs(date2.getFullYear() - date1.getFullYear())
    },
    // แก้ไขข้อมูลผู้ใช้ในModal
    async editInfo() {
      this.editData.guarantee_date_end = this.date.guarantee_date_end
      this.editData.guarantee_date_start = this.date.guarantee_date_start
      this.getYearDiff(new Date(this.date.guarantee_date_start), new Date(this.date.guarantee_date_end))
      axios
        .post('/editProject', this.editData)
        // eslint-disable-next-line no-unused-vars
        .then(response => {
          this.$swal({
            icon: 'success',
            title: '<span style="color:#000000">แก้ไขข้อมูลเรียบร้อย.</span>',
            showConfirmButton: false,
            timer: 1000,
          })
          this.resetModal()
          this.$emit('fetch')
        })
        .catch(error => {
          console.log(error)
        })
    },
    setToday() {
      const p = new Date()
      const month = (`0${p.getMonth() + 1}`).slice(-2)
      const year = p.getFullYear()
      console.log(year)
      this.searchChart.dateFrom = `${month}-${year}`
    // this.date.dateTo = new Date().toJSON().slice(0, 10).replace(/-/g, '-')
    },
    resetModal() {
      this.editData.pj_name = ''
      this.editData.contract_no = ''
      this.editData.deptid = ''
      this.editData.contract_date = ''
      this.editData.guarantee_date_start = ''
      this.editData.guarantee_year = ''
      this.editData.pj_code = ''
      this.editData.pj_value = ''
      this.selectDepartment = ''
      this.editData.deptname = ''
      this.editData.deptid = ''
      this.editData.road_id = ''
      this.editData.vendor_id = ''
    },
    handleSubmit() {
      // Exit when the form isn't valid
      if (!this.checkFormValidity()) {
        return
      }
      this.addInfo()
      this.$nextTick(() => {
        this.$refs['my-modal'].toggle('#toggle-btn')
      })
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.validationForm()
    },
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (!success) {
          // eslint-disable-next-line
          return
        }
        this.editInfo()
        this.$nextTick(() => {
          this.$bvModal.hide('modalEdit')
        })
      })
    },

    // เพิ่มข้อมูลปุ่ม Add
    dropdownDepartment() {
      axios
        .post('/dropdownDepartment')
        .then(response => {
          this.department = response.data
        })
    },
    dropdownVendor() {
      axios
        .post('/dropdownVendor')
        .then(response => {
          this.vendor = response.data
        })
    },
    dropdownRoad() {
      axios
        .post('/dropdownRoad')
        .then(response => {
          this.road = response.data
        })
    },
    addDepartment() {
      this.editData.deptid = this.selectDepartment.DeptID
      this.editData.deptname = this.selectDepartment.deptname
    },
    addRoad() {
      this.editData.road_id = this.selectRoad.id
      this.editData.road_name = this.selectRoad.wayid
    },
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
